import { CommonModule } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { ApplicationRef, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TypeaheadOrder } from 'ngx-bootstrap/typeahead';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxSummernoteModule } from 'ngx-summernote';
import { Observable, Subscription } from 'rxjs';
import { AppSettings } from 'src/app/services/AppSettings';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { HealthCareOrganization } from 'src/app/services/HealthCareOrganization';
import { JobService } from 'src/app/services/job.service';
import { JobModel } from 'src/app/services/jobModel';
import { SearchData } from 'src/app/services/searchData';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { TruncatePipe } from '../../../pipe/TruncatePipe.pipe';
import { ConnectionTemplateComponent } from '../../../templates/connection-template/connection-template.component';
import { TimezoneDatePipe } from '../../../timezone-date.pipe';
import { JobSubmitSkillfilterComponent } from '../../../widget/job-submit-skillfilter/job-submit-skillfilter.component';
// import { CandidatesPageComponent } from '../../candidate-module/candidates-page/candidates-page.component'; // Removed to break circular dependency
import { JobTemplateComponent } from '../../job-template/job-template.component';
import { SubContractModalComponent } from '../../shared/sub-contract-modal/sub-contract-modal.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PricePlanService } from '../../Price-subscritions/priceplanService';
import { ApiService } from './../../../services/api.service';
import { CommonValues } from './../../../services/commonValues';
import { UtilService } from './../../../services/util.service';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { CompactCountPipe } from '../../../pipe/compact-count.pipe';


declare var $: any;
@Component({
  selector: 'app-job-profile-detail',
  standalone: true,
  // Note: CandidatesPageComponent removed from imports to break circular dependency
  imports: [
    CompactCountPipe,
    CommonModule, ReactiveFormsModule, FormsModule, ConnectionTemplateComponent, JobSubmitSkillfilterComponent, JobTemplateComponent, InfiniteScrollModule,
NgxSummernoteModule, TruncatePipe, TimezoneDatePipe, BsDropdownModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './job-profile-detail.component.html',
  styleUrls: ['./job-profile-detail.component.scss'],
  inputs: ["jobDetails"],
  outputs: ["jobListing"],
  // NO component-level `providers: [PricePlanService]` here.
  //
  // PricePlanService is `providedIn: 'root'` and holds `expiredPopupOpen` — the
  // instance flag that stops a second "Not Enough Jobs / Candidate Slots" popup
  // from stacking (priceplanService.ts:336). A component-scoped provider gave
  // this component its OWN service instance, so on #/newjobs two independent
  // guards ran side by side — the root one used by job.component.enableJob()
  // (V3 header toggle) and this one used by our own enableJob() — each blind to
  // the other. One click then opened the popup twice. Injecting the root
  // singleton makes the guard app-wide.
  //
  // Safe: the service keeps no per-component state, only response caches
  // (PRICERESPONSE, JobSeekerUpdate) that are overwritten on every call.
})
export class JobProfileDetailComponent extends FormValidation implements OnInit, OnChanges {

  jobDetails: JobModel;
  @Input() designVersion: string = 'v2';
  jcV3MoreMenuOpen: boolean = false;
  @Input() isInSlider: boolean = false;
  @Input() candidateId: string; // For showing candidate-specific details
  candidateSpecificDetails: any = null; // Holds the candidate's specific application data
  jobListing = new EventEmitter<any>();
  @Output() jobReload = new EventEmitter<any>();
  url = AppSettings.ServerUrl + "download/";
  jobId: any;
  userId: string = localStorage.getItem('userId');
  public FORMERROR = super.Form;
  submited: boolean = false;
  candidateSupplyRef: BsModalRef;
  showmodel = false
  creditform: UntypedFormGroup;
  updateDate: any = [];
  userType: any;
  ActivateContent: string = "Update Job";
  currentTimeDate: string | Date;
  jobstatussub: Subscription;
  unit = { duration: '30' };
  bsModalRef: BsModalRef;
  public envName: any = environment.name;
  queryParamsSubscription: Subscription;
  @Output() jobDetails_Activity: EventEmitter<any> = new EventEmitter()
  dataPasstoSkillwidgets: any;
  removeTagvalues: any;
  candidateFoundStatus: string;
  candidateSearchAfterKey: any = null;
  candidateScrollStopFlag: boolean = false;
  candidateScrollLoading: boolean = false;

  // Dynamic component loading for CandidatesPageComponent (circular dependency fix)
  // Template reference to access after modal renders
  @ViewChild('candidateSupplyTemplate', { static: false }) candidateSupplyTemplate: TemplateRef<any>;
  private candidatesPageContainer: ViewContainerRef | null = null;
  private candidatesPageComponentRef: ComponentRef<any> | null = null;

  constructor(
    private api: ApiService,
    private util: UtilService,
    private modalService: BsModalService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private commonValues: CommonValues,
    private jobservice: JobService,
    private searchData: SearchData,
    private pricePlanService: PricePlanService,
    public gigsumoService: GigsumoService,
    private cdr: ChangeDetectorRef,
    private injector: Injector
  ) {
    super();

    this.userId = localStorage.getItem('userId')
    this.userType = localStorage.getItem('userType');

    this.queryParamsSubscription = this.activatedRoute.queryParams.subscribe((res) => {
      if (res) {
        this.jobId = res.jobId;
        let data: any = {};
        data.eachCandidate = true;
        data.jobId = this.jobId;

      }
    });


  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.jobDetails && changes.jobDetails.currentValue) {
      this.jobDetails = changes.jobDetails.currentValue;
      this.extractCandidateSpecificDetails();
    }
    if (changes.candidateId) {
      this.extractCandidateSpecificDetails();
    }
  }

  private extractCandidateSpecificDetails(): void {
    console.log('🔍 Extracting candidate-specific details...');
    console.log('  candidateId:', this.candidateId);
    console.log('  jobDetails exists:', !!this.jobDetails);
    console.log('  appliedBy array:', this.jobDetails?.appliedBy);
    console.log('  isInSlider:', this.isInSlider);

    if (this.candidateId && this.jobDetails && this.jobDetails.appliedBy) {
      // Find the matching entry in appliedBy array
      const matchedEntry = this.jobDetails.appliedBy.find(
        (application: any) => {
          console.log('  Checking application.userId:', application.userId, 'against candidateId:', this.candidateId);
          return application.userId === this.candidateId;
        }
      );
      this.candidateSpecificDetails = matchedEntry || null;
      console.log('  ✅ Match found:', !!matchedEntry, matchedEntry);
    } else {
      this.candidateSpecificDetails = null;
      console.log('  ❌ Missing required data - candidateSpecificDetails set to null');
    }
    console.log('  Final candidateSpecificDetails:', this.candidateSpecificDetails);
  }

  getActiveUrgencyDays(job: any): number | null {
    if (!job?.isFeatured) return null;

    const now = new Date();

    if (job?.featuredConsumptions?.length > 0) {
      const lastConsumption = job.featuredConsumptions[job.featuredConsumptions.length - 1];

      // Use toDate directly from backend (most accurate)
      if (lastConsumption.toDate) {
        const toDate = new Date(lastConsumption.toDate);
        const diffMs = toDate.getTime() - now.getTime();

        // If upgrade has expired, return null (don't show badge)
        if (diffMs <= 0) return null;

        // Convert to days, rounding up (any remaining time counts as 1 day)
        const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
        return days > 0 ? days : 1;
      }

      // Fallback: use dayCount if toDate not available
      const dayCount = lastConsumption.dayCount || 1;
      return dayCount;
    } else if (job?.featuredUpdatedOn) {
      const featuredDate = new Date(job.featuredUpdatedOn);
      const urgencyEndDate = new Date(featuredDate.getTime() + (2 * 24 * 60 * 60 * 1000));
      const diffMs = urgencyEndDate.getTime() - now.getTime();
      const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
      return days > 0 ? days : 1;
    }

    return 1;
  }

  get showSubContractButton(): boolean {
    const myBusinessId = localStorage.getItem('myBusinessId');
    if (!this.jobDetails?.tierPayRates?.length || !myBusinessId) return false;
    return this.jobDetails.tierPayRates.some(
      (tier: any) => tier.supplierBusinessId === myBusinessId && tier.subContracted === true
    );
  }

  get subContractedByName(): string | null {
    const tiers = this.jobDetails?.tierPayRates;
    if (!tiers?.length) return null;
    for (const t of tiers) {
      if (t?.subContractedByBusinessName) return t.subContractedByBusinessName;
    }
    return null;
  }

  openSubContractModal(): void {
    this.modalService.show(SubContractModalComponent, {
      initialState: {
        jobDetails: this.jobDetails,
        businessId: localStorage.getItem('businessId'),
        userId: localStorage.getItem('userId')
      },
      class: 'modal-md',
      backdrop: 'static',
      keyboard: false
    });
  }

  republishJob(): void {
    this.util.startLoader();
    this.api.updatePut('jobs/updateJob', this.jobDetails).subscribe({
      next: (res: any) => {
        this.util.stopLoader();
        if (res.code === GigsumoConstants.SUCESSCODE) {
          this.jobReload.emit('reload');
          Swal.fire({ icon: 'success', title: 'Job Republished Successfully', showConfirmButton: false, timer: 2000 });
        }
      },
      error: () => this.util.stopLoader()
    });
  }

  async featurejobvalues(): Promise<void> {
    const memberShipType = localStorage.getItem('MemberShipType');
    if (memberShipType === GigsumoConstants.FREE_PLAN) {
      this.openCreditModal();
      return;
    }
    const isPlanValid = await this.pricePlanService.checkUserPlanValid('JOBS_CANDIDATE_SPOTLIGHTS', 'FEATURED');
    if (isPlanValid && !this.jobDetails?.isFeatured) {
      this.util.startLoader();
      const payload: any = { ...this.jobDetails, isFeatured: true, consumptionType: 'JOBS_CANDIDATE_SPOTLIGHTS' };
      this.api.updatePut('jobs/updateJob', payload).subscribe({
        next: (res: any) => {
          this.util.stopLoader();
          if (res.code === GigsumoConstants.SUCESSCODE) {
            this.jobReload.emit('reload');
            Swal.fire({ icon: 'success', title: 'Job Upgraded Successfully', showConfirmButton: false, timer: 2000 });
          }
        },
        error: () => this.util.stopLoader()
      });
    } else {
      this.openCreditModal();
    }
  }

  private openCreditModal(): void {
    // Delegate to credit/upgrade flow via jobListing event so parent can handle it
    this.jobListing.emit({ action: 'upgrade', job: this.jobDetails });
  }

  object: any;
  // Single-open coordination for the "More actions" (Edit/Republish/Upgrade)
  // dropdown: closes itself when the job/candidate list's kebab or status
  // dropdown opens, and broadcasts 'detail-header' so those close in turn.
  moreActionsOpen: boolean = false;
  dropdownCoordinatorSubscription: Subscription;
  onMoreActionsToggle(open: boolean): void {
    this.moreActionsOpen = open;
    this.searchData.setDropdownState('detail-header', open);
  }
  ngOnInit() {
    this.gigsumoService.loadMyBusinessId();
    // Only update highlighter when not in slider mode to prevent nav bar highlight change
    if (!this.isInSlider) {
      this.searchData.setHighlighter('newjobs');
    }
    this.searchData.setNUllCheck("notnull");
    this.dropdownCoordinatorSubscription = this.searchData.getDropdownState().subscribe(state => {
      if (state.open && state.type !== 'detail-header') {
        this.moreActionsOpen = false;
      }
    });
  }
  updateJobObject(JobObject): void {
    if (this.jobDetails.jobId == JobObject.jobId) {
      this.jobDetails.status = JobObject.status
    }
  }
  ngOnDestroy() {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
    if (this.jobstatussub) {
      this.jobstatussub.unsubscribe();
    }
    if (this.dropdownCoordinatorSubscription) {
      this.dropdownCoordinatorSubscription.unsubscribe();
    }
    // Clean up dynamically loaded component
    if (this.candidatesPageComponentRef) {
      const appRef = this.injector.get(ApplicationRef);
      appRef.detachView(this.candidatesPageComponentRef.hostView);
      this.candidatesPageComponentRef.destroy();
      this.candidatesPageComponentRef = null;
    }
  }
  @Output() jobReloadFromJobComponent = new EventEmitter<any>();
  reloadJobData(event: any) {
    this.jobReloadFromJobComponent.emit(event);
  }
  connect(userId: string) {
    let datas: any = {};
    datas.userId = userId;
    datas.requestedBy = localStorage.getItem('userId');

    this.api.create("user/connect", datas).subscribe((conData) => {

      console.warn("Connection Response data: ", conData);
      if (conData.code === "00000") {
        Swal.fire({
          icon: "success",
          title: "Connection request sent successfully",
          showConfirmButton: false,
          timer: 2000,
        }).then((result) => {
        });
      } else if (conData.code === "88888") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Oops..",
          text: "Sorry, connection request failed. Please try after some time",
          showConfirmButton: false,
          timer: 3000,
        });

      }
    }, err => {

    });
  }

  extractText(val: string) {
    return FormValidation.extractContent(val);
  }


  fromBusinessPage: boolean = false
  c: any;
  d: any;
  fromBusinessPageId: any;



  closeCandidateSupplyModal() {
    this.modalService.hide(1);
    this.dataPasstoSkillwidgets = [];
  }

  applyResponse: any = [];
  myCandidatesForApply(jobId: string, candidateSupplyTemplate: any) {
    const responseData: any = {
      "source": {
        "all": false,
        "myCandidates": true,
        "allPlatFormCandidates": false,
        "teamCandidates": false,
        "benchNetworkCandidates": false,
        "freeLancerNetworkCandidates": false,
        "mtaNetworkCandidates": false,
        "jobSeekerNetworkCandidates": false,
        "featured": false,
        "suggestedCandidates": false
      },
      "workType": {
        "all": false,
        "remoteWork": false,
        "relocationRequired": false,
        "workFromHome": false
      },
      "jobId": jobId,
      "workAuthorization": [],
      "engagementType": [],
      "availableIn": [],
      "status": [],
      "searchAfterKey": null,
      "city": null,
      "state": null,
      "country": null,
      "zipCode": null,
      "submissionFilters": [],
      "postedFrom": null,
      "postedTo": null,
      "limit": 10,
      "userId": this.userId,
      "searchContent": ""
    }

    // Reset scroll state for new modal open
    this.candidateSearchAfterKey = null;
    this.candidateScrollStopFlag = false;
    this.candidateScrollLoading = false;

    this.api.create('candidates/filter', responseData).subscribe(res => {
      console.log("APLY_RESPONSE  ", res);
      if (res.code === GigsumoConstants.SUCESSCODE) {
        this.applyResponse = res.data.candidateList;
        if (this.applyResponse.length === 0) {
          this.candidateFoundStatus = "Couldn't find any Candidates for the applied filters.";
        }

        // Capture searchAfterKey for pagination
        const searchAfterKey = res.data.searchAfterKey;
        if (searchAfterKey && searchAfterKey.length > 0) {
          this.candidateSearchAfterKey = searchAfterKey;
        } else {
          this.candidateScrollStopFlag = true;
        }

        const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
        this.candidateSupplyRef = this.modalService.show(candidateSupplyTemplate, config);

        // Load CandidatesPageComponent dynamically after modal is rendered
        setTimeout(() => {
          this.cdr.detectChanges();
          this.loadCandidatesPageComponent();
        }, 150);
      }
    });


  }

  onCandidateSupplyScroll() {
    if (this.candidateScrollStopFlag || this.candidateScrollLoading || !this.candidateSearchAfterKey) {
      return;
    }

    this.candidateScrollLoading = true;
    const jobId = this.jobData?.jobId;

    const responseData: any = {
      "source": {
        "all": false,
        "myCandidates": true,
        "allPlatFormCandidates": false,
        "teamCandidates": false,
        "benchNetworkCandidates": false,
        "freeLancerNetworkCandidates": false,
        "mtaNetworkCandidates": false,
        "jobSeekerNetworkCandidates": false,
        "featured": false,
        "suggestedCandidates": false
      },
      "workType": {
        "all": false,
        "remoteWork": false,
        "relocationRequired": false,
        "workFromHome": false
      },
      "jobId": jobId,
      "workAuthorization": [],
      "engagementType": [],
      "availableIn": [],
      "status": [],
      "searchAfterKey": this.candidateSearchAfterKey,
      "city": null,
      "state": null,
      "country": null,
      "zipCode": null,
      "submissionFilters": [],
      "postedFrom": null,
      "postedTo": null,
      "limit": 10,
      "userId": this.userId,
      "searchContent": ""
    };

    this.api.create('candidates/filter', responseData).subscribe(res => {
      this.candidateScrollLoading = false;
      if (res.code === GigsumoConstants.SUCESSCODE) {
        const candidateList = res.data.candidateList;
        const searchAfterKey = res.data.searchAfterKey;

        if (!candidateList || candidateList.length === 0 ||
          JSON.stringify(this.candidateSearchAfterKey) === JSON.stringify(searchAfterKey)) {
          this.candidateScrollStopFlag = true;
          return;
        }

        // Append new candidates
        this.applyResponse = [...this.applyResponse, ...candidateList];

        // Update searchAfterKey for next page
        if (searchAfterKey && searchAfterKey.length > 0) {
          this.candidateSearchAfterKey = searchAfterKey;
        } else {
          this.candidateScrollStopFlag = true;
        }

        // Update the dynamically loaded component with new data
        if (this.candidatesPageComponentRef) {
          this.candidatesPageComponentRef.instance.passValues = this.applyResponse;
          this.candidatesPageComponentRef.instance.syncFormArrayWithPassValues();
          this.candidatesPageComponentRef.changeDetectorRef.detectChanges();
        }
      }
    }, () => {
      this.candidateScrollLoading = false;
    });
  }

  termsCheck: boolean = false;
  resumeData: any = [];
  rtrFormData: any;
  getchildData(data: any) {
    this.termsCheck = data.terms;
    if (data.resumes) {
      this.resumeData = data.resumes
    }
    if (data.value != null) {
      this.dataPasstoSkillwidgets = data.value;
      this.rtrFormData = data.formData;
    } else {
      this.dataPasstoSkillwidgets = [];
    }

  }

  removeUserfromTag(data) {
    console.log("removeUserfromTag", data);
    this.removeTagvalues = data;
    this.applyResponse.forEach(element => {
      if (element.candidateId == data.candidateId) {
        element.isSelected = false;
      }
    });

    this.dataPasstoSkillwidgets.forEach(element => {
      if (element.candidateId == data.candidateId) {
        element.isSelected = false;
      }
    });

    if(data=='CLEAR'){
      this.dataPasstoSkillwidgets = [];
    }
  }

  async proceedToApply(values, candidateSupplyTemplate) {
    try {
      this.util.startLoader();

      if (this.pricePlanService.ACTIVE_INTERACTION === 0 && this.userType != "JOB_SEEKER") {
        const userData = await this.pricePlanService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
        let {  membershipType } = userData;
        let availablePoints = null;
        let actualPoints = null;
        let utilizedPoints = null;
        let promotional = null;
        userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available
            actualPoints = ele.actual
            utilizedPoints = ele.utilized
            promotional = ele.promotional
          }
        })
        let popupType: "PAY" | "LIMIT"   | "UPGRADE" = "PAY";

        if (['Starter','Growth','ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";
        }
        this.pricePlanService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null,null, availablePoints, actualPoints, utilizedPoints, promotional);
        return;
      }
      this.myCandidatesForApply(values.jobId, candidateSupplyTemplate);
      this.c = this.activatedRoute.pathFromRoot[0]['_routerState']['snapshot'].url
      this.d = this.c.substr(1, 8)
      if (this.d == 'business' && localStorage.getItem('isAFollower') == 'false') {
        Swal.fire({
          icon: "info",
          title: "Following Required!",
          text: "Please, follow the business page for applying the job.",
          showConfirmButton: true,
        });
      } else {

        if (this.d == 'business') {

          this.fromBusinessPage = true
          this.fromBusinessPageId = localStorage.getItem('businessId')

        } else {
          this.fromBusinessPage = false
        }

        // why i cmd, this one override the clientType in ui after apply buttom click so cmd this;
        // values.clientType = values.user.clientType;  

        values.userType = values.user.userType;
        let datas: any = {};
        var datacheck = [{ 'userId': localStorage.getItem('userId') }]
        datas.jobPostedBy = localStorage.getItem('userId');
        datas.jobId = values.jobId;
        datas.appliedBy = datacheck;
        values.jobfilter = true;
        values.filterTitle = 'Select';
        if (this.fromBusinessPage == true) {
          values.fromBusinessPage = true
          values.fromBusinessPageId = this.fromBusinessPageId
        } else {
          values.fromBusinessPage = false
        }
        // values.jobDescription = "";
      }

    } catch (error) {
      this.util.stopLoader();
    }
    finally {
      setTimeout(() => {
        this.util.stopLoader();
      }, 1000);
    }

  }

  // checkConnectionStatus(values): Observable<any> {
  //   const apiURL = 'user/checkConnectionStatus';
  //   const params = new HttpParams()
  //     .set('userId', this.userId)
  //     .set('connnectorId', values.jobPostedBy);

  //   const urlWithParams = `${apiURL}?${params.toString()}`;
  //   return this.api.query(urlWithParams);
  // }

  connectionStatus: string;
  connectionRequestRef: BsModalRef;
  values: any;
  counterpartsDetails: any;
  openConnectionTemplate(connectionStatus, values, connectionTempate?: TemplateRef<any>) {
    this.connectionStatus = connectionStatus;
    this.values = values;
    const initialState: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'sm',
    };
    this.api.query("user/" + this.values.jobPostedBy).subscribe(res => {
      if (res.code == '00000') {
        this.counterpartsDetails = res;
        this.connectionRequestRef = this.modalService.show(connectionTempate, initialState);
      }
    })
  }
  checkConnectionStatus(values): Observable<any> {
    const apiURL = 'user/checkConnectionStatus';
    const params = new HttpParams()
      .set('userId', this.userId)
      .set('connnectorId', values.createdBy);

    const urlWithParams = `${apiURL}?${params.toString()}`;
    return this.api.query(urlWithParams);
  }

  jobData: any;
  apply(values: any, template?: TemplateRef<any>, candidateSupplyTemplate?: TemplateRef<any>) {
    this.jobData = values;
    if (values.isFeatured) {
      this.proceedToApply(values, candidateSupplyTemplate);
    } else if (!values.isFeatured) {
      if (values.connectionStatus === 'CONNECTED') {
        this.proceedToApply(values, candidateSupplyTemplate);
      } else if (values.connectionStatus !== 'CONNECTED') {
        this.proceedToApply(values, candidateSupplyTemplate);
        // to be used later
        // this.openConnectionTemplate(values.connectionStatus, values, template);
      }
    }
  }

  zipCodeValidaiton(x: number): boolean {
    if (String(x).length > 10) {
      return false;
    }
    return true;
  }
  uniqueOrgList1: Array<Partial<HealthCareOrganization>> = [];
  searchBarShow1: boolean = false;
  closemodel() {
    this.modalRef.hide();
  }

  // Blocks re-entry while a status change is in flight. checkUserPlanValid()
  // is a network round trip, so without this a second toggle click lands
  // before the first resolves and both reach expiredPopup() — showing the
  // "Not Enough Jobs / Candidate Slots" popup twice. Same pattern as
  // job.component.ts `isProcessingStatusChange`.
  isProcessingStatusChange: boolean = false;
  async enableJob(event) {
    if (this.isProcessingStatusChange) {
      // Undo the toggle the blocked click just flipped, so the switch keeps
      // showing the job's real state.
      const blocked = event.target as HTMLInputElement;
      blocked.checked = !blocked.checked;
      return;
    }
    this.isProcessingStatusChange = true;

    try {
      if (event.target.checked) {
        const isPlanValid = await this.pricePlanService.checkUserPlanValid("JOB_CANDIDATE_POSTINGS", "JOBS_CANDIDATES");
        if (isPlanValid) {
          this.afterPlanValidationstatuschange(event);
        } else {
          const input = event.target as HTMLInputElement;
          input.checked = false;
        }
      } else {
        this.afterPlanValidationstatuschange(event);
      }
    } finally {
      // Small tail so the rapid second click of a double-click is still caught
      // after the await resolves.
      setTimeout(() => {
        this.isProcessingStatusChange = false;
      }, 500);
    }
  }


  afterPlanValidationstatuschange(event) {
    const newStatus = event.target.checked ? 'ACTIVE' : 'ON HOLD';
    if (this.jobDetails.status === newStatus) {
      return;
    }

    if (event.target.checked == true) {
      if (this.jobDetails.status != 'ACTIVE' && this.jobDetails.status != 'DRAFTED' && this.jobDetails.status != 'AWAITING HOST') {
        this.ActivateContent = 'Activate Job'
      }
      this.jobDetails.status = 'ACTIVE'

    } else if (event.target.checked == false) {
      this.jobDetails.status = 'ON HOLD'
    }
    if (localStorage.getItem('MemberShipType') !== 'Free') {
      this.jobDetails.businessId = localStorage.getItem('myBusinessId') || null;
    }
     this.util.startLoader()
    this.api.updatePut('jobs/updateJob', this.jobDetails).subscribe(res => {
      if (res.code == '00000') {
        this.util.stopLoader()
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Job updated successfully",
          showConfirmButton: false,
          timer: 2000,
        });
        this.jobDetails = res.data.jobData
        this.jobListing.emit({
          content: "STATUS_UPDATED",
          data: res.data.jobData
        });

      }
    })
  }


  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    // scroll
  };


  serverCurrentDate: string;
  servertimedate: string;

  otherSelectedStates: any = []
  FormData: any;
  uploadFiles: Array<any> = [];
  recruiterTitleList: any = []
  engagementTypeList = []
  workAuthorizationList: any = []
  jobPostForm: UntypedFormGroup;
  freelancerInternalHireFlag: boolean = false
  primarySkillsSelected = [];
  secondarySkillsSelected = [];
  stateListCA: any = []
  stateListIN: any = []
  stateListAU: any = []
  countryList: any = [];
  submit: boolean = false
  currentTime: any;
  maxDate: any
  onChangePeriod(value) {

  }

  showToggleValue: boolean = true;
  payType: null;
  targetRate: null;
  figureLength: number = 0;
  selectedCountries: boolean = false
  typeTargetValue: null;
  countryChosen: null;
  commonVariables: any = {};
  noResult: boolean = false
  onChngOrg(event) {
    this.jobPostForm.patchValue({
      organisationId: event.organizationId
    })

  }


  sortConfigWork: TypeaheadOrder = {
    direction: "desc",
    field: "organisationName",
  };



  candidateJobTitleList: any = []
  jobPostedBehalfOflist: any = []
  modalRef: BsModalRef;
  modalOpen: boolean = false;
  toggleOpen: boolean = false;
  otherStatesList: any = [];

  //opening in job modal in jobprofile component by monisha
  @ViewChild(JobTemplateComponent, { static: false }) jobTemplateComponent: JobTemplateComponent; // Reference to the JobTemplateComponent
  async editJob(item) {
    if (this.jobTemplateComponent) {
          this.jobTemplateComponent.openJobModal(item); // Open the modal
         }
  }

  /**
   * Dynamically loads CandidatesPageComponent to break circular dependency
   * Called after modal is opened and template is rendered
   */
  async loadCandidatesPageComponent(retryCount: number = 0) {
    const maxRetries = 5;

    // If container hasn't been found yet, try to get it from the modal's DOM
    if (!this.candidatesPageContainer) {
      if (retryCount < maxRetries) {
        // Try to find the container element in the modal's DOM
        const containerElement = document.getElementById('candidatesPageDynamicContainerJobProfileDetail');

        if (!containerElement) {
          const delay = 50 * Math.pow(2, retryCount); // 50ms, 100ms, 200ms, 400ms, 800ms
          console.log(`[JobProfileDetail] CandidatesPageContainer not ready, retrying in ${delay}ms (attempt ${retryCount + 1}/${maxRetries})`);
          setTimeout(() => this.loadCandidatesPageComponent(retryCount + 1), delay);
          return;
        }
      } else {
        console.error('[JobProfileDetail] CandidatesPageContainer not available after maximum retries');
        return;
      }
    }

    console.log('[JobProfileDetail] Proceeding with dynamic component load...');

    try {
      console.log('[JobProfileDetail] Loading CandidatesPageComponent dynamically...');

      // Dynamic import to break circular dependency
      const { CandidatesPageComponent } = await import('../../candidate-module/candidates-page/candidates-page.component');

      // Get the container element
      const containerElement = document.getElementById('candidatesPageDynamicContainerJobProfileDetail');

      if (containerElement) {
        // Clear previous content
        containerElement.innerHTML = '';

        // Use ApplicationRef to create and attach the component
        const componentFactory = this.injector.get(ComponentFactoryResolver);
        const factory = componentFactory.resolveComponentFactory(CandidatesPageComponent);

        // Create the component
        this.candidatesPageComponentRef = factory.create(this.injector);

        // Set inputs
        this.candidatesPageComponentRef.instance.viewSize = 'extra-small';
        this.candidatesPageComponentRef.instance.passValues = this.applyResponse;
        this.candidatesPageComponentRef.instance.jobData = this.jobData;
        this.candidatesPageComponentRef.instance.fromApply = true;
        this.candidatesPageComponentRef.instance.candidatesFoundStatus = this.candidateFoundStatus;
        this.candidatesPageComponentRef.instance.removeTag = this.removeTagvalues;

        // Subscribe to outputs
        this.candidatesPageComponentRef.instance.selectedCandidate.subscribe((data: any) => {
          this.getchildData(data);
        });

        // Attach the component's host view to the application
        const appRef = this.injector.get(ApplicationRef);
        appRef.attachView(this.candidatesPageComponentRef.hostView);

        // Append the component's DOM element to our container
        const domElem = (this.candidatesPageComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
        containerElement.appendChild(domElem);

        // Trigger change detection
        this.candidatesPageComponentRef.changeDetectorRef.detectChanges();

        console.log('[JobProfileDetail] CandidatesPageComponent loaded successfully');
      } else {
        console.error('[JobProfileDetail] Container element not found in DOM');
      }
    } catch (error) {
      console.error('[JobProfileDetail] Error loading CandidatesPageComponent:', error);
    }
  }

}
